import React from 'react';
import Logo from '../components/Logo';
import Description from './signup/description';
import {Link} from "react-router-dom";


const PageWrapper = ({children, title = 'Sign Up', isLowContent = false, isLogin = false, signUp}) => (
  <div className="container-fluid h-100 auth-page">
    <div className="row h-100">
      <div className={(isLogin ? 'col-md-5' : 'col-md-7') + ' h-100'}>
        <div className="row h-100">
          <div className="offset-md-1 col-md-10 h-100 d-flex flex-column justify-content-between">
            <Logo small className="mt-5"/>
            <div>
              {children}
            </div>
            {isLowContent || isLogin ?
              <p className="text-medium-grey p mb-5">
                <span>©2021 All Rights Reserved. FastMap® is a registered trademark of FastMap Inc. </span>
                <Link to={{ pathname: 'https://www.fastmap.ai/legal/privacy'}} className={'link-underline'} target="_blank">Privacy Policy</Link>.
                <span> and </span>
                <Link to={{ pathname: 'https://www.fastmap.ai/legal/terms'}} className={'link-underline'} target="_blank">Terms</Link>
              </p>
              :
              <p className="text-medium-grey mb-5 pb-5 pt-5">
                <span>By clicking the "{title}" button, you are creating a FastMap account, and you agree to FastMap's </span>
                <Link to={{ pathname: 'https://www.fastmap.ai/legal/terms'}} className={'link-underline'} target="_blank">Terms of Use</Link>
                <span> and </span>
                <Link to={{ pathname: 'https://www.fastmap.ai/legal/privacy'}} className={'link-underline'} target="_blank">Privacy Policy</Link>.
              </p>
            }
          </div>
        </div>
      </div>
      <div className={(isLogin ? 'col-md-7 login-page' : 'col-md-5 not-login-page') + ' h-100'}>
        {isLogin ?
          <div
            className="row h-100 auth-page-description"
            style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {/* <div style={{marginTop: '200px',}}>
              <div style={{fontSize: '28px', fontWeight: 500, textAlign: 'center'}}>Promotional Title</div>
              <div style={{fontSize: '18px', color: '#E5E5E5', textAlign: 'center', marginTop: '30px'}}>
                Add description of new features, collected cities, or other <br/>
                customer value they can see and understand at login.
              </div>
            </div> */}
          </div>
          :
          <Description isLowContent={isLowContent} signUp={signUp}/>
        }
      </div>
    </div>
  </div>
)

export default PageWrapper;
